<template>
  <div>
    <div class="policy notifCont">
      <div>
        <b-tooltip multilined type="is-light" :position="position">
          <b-tag type="is-success" class="is-small">
            <b-icon icon="star" size="is-small"></b-icon>
            <span v-if="type == 'car'">Preferred Vendor </span>
            <span v-if="type == 'hotel'">Preferred Hotel </span>
            <span v-if="type == 'air'">Preferred Airline </span>
          </b-tag>
          <template v-slot:content>
            <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
              This vendor is preferred by your company
            </h5>
          </template>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreferredVendorTag",
  props: {
    type: String,
    position: {
      type: String,
      default: "is-bottom",
    },
  },
  data() {
    return {
      // active: false,
    };
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
